// lang-en.ts

export const LANG_EN_NAME = 'en';

export const LANG_EN_TRANS = {

    // Login
    'msgConnect': 'Login to JuJu',
    'username': 'Email or username',
    'password': 'Password',
    'login': 'Login',
    'requiredUsername': ' Username is required',
    'requiredPassword': 'Password is required',
    'errorConnexion': 'Username or password is incorrect',
    // Navbar
    'Infos':'Project',
    'logout': 'Logout',
    'respondents': 'Respondents',
    'statistics': 'Statistics',
    'searchFilter': 'Search Filter',
    'Terminal':'Terminal',
    // search
    'search...': 'Search...',
    'erase' : 'Erase',
    'save' : 'Save',
    'addChoice':'Add Choice',
    'add' : 'Add',
    'dates' : 'Dates',
    'synchro' : 'Synchro',
    'emailStatus' : 'Email Status',
    'answer' : 'Answer',
    // download
    'download': 'Download',
    'excelReport':'Excel Report',
    'htmlReport':'HTML Report',
    'pictures' : 'Pictures',
    'gifs':'Gifs',
    'picturesAnim' : 'Pictures Anim',
    'videos' : 'Videos',
    'report':'Report',
    // respondent one by one
    'synchroTime': 'Synchro Time',
    'savedTime': 'Saved Time',
    'details': 'Details',
    // respondent by synchro
    'time': 'Time',
    'user' : 'User',
    'device' : 'Device',
    // Statistics
    'general' : 'General',
    'total' : 'Total',
    'totalRespondents' : 'Total respondents',
    'emailSent' : 'Email sent',
    'emailOpened' : 'Email opened',
    'smsSent' : 'Sms sent',
    'clicks' : 'Clicks',
    'from' : '	From',

    // Project Infos
    'startDate' : 'Start Date',
    'endDate' : 'End Date',
    'projectName' : 'Name',
    'projectCode' : 'Code',
    'projectClient' : 'Client',
    'projectUserName' : 'UserName',
    'projectPassword' : 'Password',
    'projectTags' : 'Tags',
    'new' : 'New...',
    // Questionnaire Infos
    'title' : 'Title',
    'sms' : 'Sms',
    'email' : 'Email',
    'languages' : 'Supported Languages',
    'picture_transformation' : 'Picture Transformation',
    'hashtag_subscription' : 'Hashtag Subscription',
    'files' : 'Files'
};
